import React, {ReactElement} from "react"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSectionTable} from "../../containers/MainSection/MainSection"
import ManagedSolutionsCustomersTable from "../../components/ManagedSolutionsCustomers/ManagedSolutionsCustomersTable"
import {usePaging} from "../../hooks/usePaging"
import {useAccessToken} from "../../services/auth"
import {findManagedSolutionsCustomers, exportManagedSolutionsCustomers} from "../../resources/managedSolutions"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {DataTableActionHeader, DataTableCard, TablePending} from "../../components/DataTable/DataTable"
import {useQueryState} from "use-location-state"
import {downloadFile} from "../../utilities/file"
import {useToasts} from "react-toast-notifications"

export function ManagedSolutionsCustomersPage(): ReactElement {
	const accessToken = useAccessToken()
	const {addToast} = useToasts()
	const limit = 40

	const [sortBy, setSortBy] = useQueryState("rtl-cust--sort", "-createdAt")

	const [result, hasPrev, hasNext, prev, next, hasResults, reset] = usePaging(
		limit,
		(offset, limit) => findManagedSolutionsCustomers(accessToken, offset, limit, sortBy),
		(x) => x.data.length,
		[sortBy],
		"rtl-cust",
		true
	)

	const toggleSort = () => {
		setSortBy(sortBy === "-createdAt" ? "createdAt" : "-createdAt")
		reset(limit)
	}

	async function exportCustomers() {
		const response = await exportManagedSolutionsCustomers(accessToken, sortBy)
		response.match(
			(d) => downloadFile("ManagedSolutionsCustomers.csv", d, "text/csv"),
			() => addToast("Something went wrong", {appearance: "warning"})
		)
		return true
	}

	return (
		<>
			<TitleBar title={"Customers"} />

			<MainSectionTable>
				<DataTableCard className={"managed-solutions-customers-card"}>
					<DataTableActionHeader enableSticky={true} exportFunc={exportCustomers} />
					<AsyncResultComponent asyncResult={result} pendingComponent={<TablePending numberOfRows={2} />}>
						{({value: customers}) => {
							return (
								<ManagedSolutionsCustomersTable
									customers={customers.data}
									hasResults={hasResults}
									hasPrev={hasPrev}
									hasNext={hasNext}
									prev={prev}
									next={next}
									isUsingPaging={true}
									fullHeight={true}
									meta={customers.meta}
									sortBy={sortBy}
									sortFunction={toggleSort}
								/>
							)
						}}
					</AsyncResultComponent>
				</DataTableCard>
			</MainSectionTable>
		</>
	)
}
